import { Card } from "@/components/ui/card";
import { useDocumentTitle } from "usehooks-ts";
import InvoiceTable from "./table";

const OrganizationInvoices = () => {
  useDocumentTitle("Financials");

  return (
    <div className="w-full p-5">
      <Card className="pt-4">
        <InvoiceTable />
      </Card>
    </div>
  );
};

export default OrganizationInvoices;
